import './Container.scss'

import cn from 'classnames'

export type IProps = {
  children: React.ReactNode
  className?: string
  size?: 'xs' | 's' | 'm' | 'l' | 'infinity'
}

const Container = ({ children, size = 'm', className = '' }: IProps) => {
  return (
    <div
      className={`${cn('container', `container--size-${size}`, {
        [`${className}`]: !!className,
      })}`}
    >
      {children}
    </div>
  )
}

export default Container
